/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfProductListItemDto } from '../../models/paginated-dto-of-product-list-item-dto';

export interface GetVariants$Params {
  productId: number;
}

export function getVariants(http: HttpClient, rootUrl: string, params: GetVariants$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfProductListItemDto>> {
  const rb = new RequestBuilder(rootUrl, getVariants.PATH, 'get');
  if (params) {
    rb.path('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfProductListItemDto>;
    })
  );
}

getVariants.PATH = '/api/v1/products/{productId}/variants';
